import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DownloadElement, DownloadService } from '../shared/services/download.service';

// Pointer to Google Analytics gTag function defined in index.html
declare let gtag: Function;

/** Tech Library PDF Viewer  */
@Component({
    selector: 'pd-tech-library-viewer',
    templateUrl: './tech-library-viewer.component.html',
    styleUrls: ['./tech-library-viewer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TechLibraryViewerComponent implements OnInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    fileName = "Tech Library.pdf";
    pdfLoadError = false;
    pdfLoading = true;
    catalogLoadError = false;
    catalogLoading = true;
    id: string = '';
    category: string = '';
    autoDownload = false;
    techLibrary: DownloadElement;

    @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand: any;

    get loading(): boolean {
        return this.pdfLoading;
    }

    get loadError(): boolean {
        return this.pdfLoadError;
    }

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private downloadService: DownloadService
    ) { }

    ngOnInit() {
        this.route.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
            let libraryName: string;

            if (params['name']) {
                libraryName = params['name'];
            }

            this.downloadService.downloadsUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
                if (list) {
                    list.forEach(element => {
                        if ( libraryName ) {
                            if ( libraryName === element.name ) {
                                this.techLibrary = element;
                            }
                        } else {
                            if ( element.type === 'techlibrary' && (!this.techLibrary || (this.techLibrary && element.version > this.techLibrary.version)) ) {
                                this.techLibrary = element;
                            }
                        }
                    });
    
                    this.fileName = this.techLibrary ? this.techLibrary.name : '';

                    gtag('event', 'file_download', {
                        'event_label' : this.fileName,
                        'file_type': 'Technology & Services Catalog'
                    });

                    this.downloadFile();
                } else {
                    this.pdfLoadError = this.downloadService.loadFailed;
                    if ( !this.pdfLoadError ) {
                        this.downloadService.refresh();
                    } else {
                        this.pdfLoading = false;
                    }
                }
            });
        });
    }

    downloadFile(): void {
        let element: DownloadElement = this.techLibrary;

        this.http.get(environment.azure.url + '/document?file=' + element.azureID, { responseType: 'blob' }).subscribe({
            next: (data) => {
                this.pdfLoading = false;
                this.pdfLoadError = false;

                this.pdfViewerOnDemand.pdfSrc = new Blob([data], { type: element.fileType });
                this.pdfViewerOnDemand.refresh();
            },
            error: (msg) => {
                this.pdfLoading = false;
                this.pdfLoadError = true;
                console.log(msg);
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
